import { useMutation } from 'react-query'

import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'

export const useMutateSendApprovalReminder = () => {
  const { mutateAsync } = useMutation({
    mutationFn: async ({ id, message }: { id: number; message: string }) => {
      return expenseRepository.sendReminder(id, message)
    },
  })

  return { sendReminder: mutateAsync }
}
